import styled, { Interpolation } from "styled-components";
import { colors } from "@/theme";

export const CoopInfoItemContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  row-gap: 8px;
`;

export interface CoopInfoItemProps {
  $styles?: Interpolation<React.CSSProperties>;
}

export const CoopInfoItemHeader = styled.div<CoopInfoItemProps>`
  ${({ $styles }) => $styles}
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-transform: capitalize;
`;

export const CoopInfoItemData = styled.div<CoopInfoItemProps>`
  ${({ $styles }) => $styles}
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  text-transform: uppercase;
`;
